export default "__VITE_ASSET__B_8wc0M4__"